import JobTimelineEntry from './JobTimelineEntry';
import { observable, computed, makeObservable } from 'mobx';
import Employee from 'main/stores/employees/Employee';
import _ from 'lodash';
import {types} from 'main/tools';
import EmployeeCustomField from '../employee_custom_fields/EmployeeCustomField';

class EmploymentRecord extends JobTimelineEntry {
  jobTitle;
  employmentType;
  location;
  department;
  manager;
  payRateFormatted;
  payRateUnit;
  payFrequency;
  payRate;
  payRateCurrency;
  hoursPerWeek;
  commission;
  commissionStructure;
  bonus;
  bonusStructure;
  annualizedCommissionFormatted;
  annualizedCommission;
  employmentRecordCustomFields;

  _relations = {
    ...this._relations,
    manager: Employee,
    employmentRecordCustomFields: [EmployeeCustomField]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      jobTitle: observable,
      employmentType: observable,
      location: observable,
      department: observable,
      manager: observable,
      payRateFormatted: observable,
      payRateUnit: observable,
      payFrequency: observable,
      payRate: observable,
      payRateCurrency: observable,
      hoursPerWeek: observable,
      commission: observable,
      commissionStructure: observable,
      bonus: observable,
      bonusStructure: observable,
      annualizedCommissionFormatted: observable,
      annualizedCommission: observable,
      employmentRecordCustomFields: observable,
      commissionView: computed,
      bonusView: computed,
      hasComment: computed,
      employmentTypeView: computed,
      payRateUnitView: computed
    });

    this.merge(other);
  }

  _afterMerge() {
    this._type = types.EMPLOYMENT_RECORD;
  }

  get commissionView() {
    return this.commission ? 'Yes' : 'No';
  }

  get bonusView() {
    return this.bonus ? 'Yes' : 'No';
  }

  get hasComment() {
    return !_.isEmpty(this.comment);
  }

  get employmentTypeView() {
    if (this.employmentType) {
      return `models.employment_record.employment_type.${this.employmentType}`;
    }

    return '';
  }

  get payRateUnitView() {
    if (this.employmentType) {
      return `models.employment_record.pay_rate_unit.${this.payRateUnit}`;
    }

    return '';
  }
}

export default EmploymentRecord;
